/**
 * Clones the element matching the given selector, inserts the clone after the 10th or 8th child element of product-list depending on viewport width,
 * removes the original element, and updates the grid area class name of the shop-the-look element accordingly.
 * Called initially and on window resize to handle responsive layout changes.
 */
function cutAndPasteElement(selector, index1, index2) {
  if (window.location.href.indexOf("filter")) {
    const elementToMove = selector ? selector : "";
    if (elementToMove) {
      if (window.innerWidth >= 1720) {
        console.log('cutting');
        let element = document.querySelector(selector);
        let copy = element.cloneNode(true);
        let selectedElement = document.querySelector(`product-list > div:nth-child(${index1})`);
        selectedElement.parentNode.insertBefore(copy, selectedElement.nextSibling);
        element.remove();
      } else {
        let element = document.querySelector(selector);
        let copy = element.cloneNode(true);
        let selectedElement = document.querySelector(`product-list > div:nth-child(${index2})`);
        selectedElement.parentNode.insertBefore(copy, selectedElement.nextSibling);
        element.remove();
      }
    }
  }
}

setTimeout(() => {
  if (document.querySelector('[data-name="promo-collection"]')) {
    cutAndPasteElement('[data-name="promo-collection"]', 11, 8);
  }
  if (document.querySelector('[data-name="shop-the-look"]')) {
    cutAndPasteElement('[data-name="shop-the-look"]', 42, 42);
  }
}, 2000);

window.onresize = function () {
  if (document.querySelector('[data-name="promo-collection"]')) {
    cutAndPasteElement('[data-name="promo-collection"]', 11, 8);
  }
  if (document.querySelector('[data-name="shop-the-look"]')) {
    cutAndPasteElement('[data-name="shop-the-look"]', 42, 42);
  }
};